<template>
  <div class="part-ten-container">
    <div class="part-ten">
      <div class="part-ten-top-content">
        <!-- <a class="part-ten-top-content-item"
          href="https://www.yunzmall.com/plugins/shop_server/notice?class_id=0&i=10&mid=277" style="">
          <img
            src="https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2021/09/d8eaa1d858e33b9665bfd7fffe24a476.png"
            alt="" style="width:60px;height:60px">
          <div class="text">
            <div class="h3">专注于智慧商业</div>
            <div class="h4">懂电商运营，更懂智慧商业系统</div>
          </div>
        </a>
        <a class="part-ten-top-content-item"
          href="https://www.yunzmall.com/plugins/shop_server/knowledge/knowledge_detail/21?base_id=17&i=10&mid=62000">
          <img
            src="https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2021/09/cb99dbd8bffb049eacac2cd5ca91a65f.png"
            alt="" style="width:60px;height:60px">
          <div class="text">
            <div class="h3">0元下载体验</div>
            <div class="h4">支持免费下载到本地安装部署</div>
          </div>
        </a>
        <a class="part-ten-top-content-item" href="https://www.yunzmall.com/plugins/shop_server/articleContent/44?i=10">
          <img
            src="https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2021/09/f5212f2f8362839fe2e66bf7f932858e.png"
            alt="" style="width:60px;height:60px">
          <div class="text">
            <div class="h3">1对1技术支持</div>
            <div class="h4">专属客户经理提供技术支持</div>
          </div>
        </a>
        <a class="part-ten-top-content-item"
          href="https://www.yunzmall.com/plugins/shop_server/knowledge/knowledge_detail/526?base_id=12&i=10&mid=62000">
          <img
            src="https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2021/09/5746a2dc068009c6f15838e911ef67dd.png"
            alt="" style="width:60px;height:60px">
          <div class="text">
            <div class="h3">交易合同发票</div>
            <div class="h4">为企业合作保驾护航</div>
          </div>
        </a> -->


        <div class="flex-center">
          <img :src="require('../assets/image_1/396.png')" alt="">
          <div>
            <div class="bold c-fff fz-20 mb-15 lh-1">专注智慧商业</div>
            <div class="c-939397 fz-18 w400 lh-1">懂技术更懂商业市场</div>
          </div>
        </div>
        <div class="flex-center">
          <img :src="require('../assets/image_1/398.png')" alt="">
          <div>
            <div class="bold c-fff fz-20 mb-15 lh-1">客户价值为先</div>
            <div class="c-939397 fz-18 w400 lh-1">致力为客户创造价值</div>
          </div>
        </div>
        <div class="flex-center">
          <img :src="require('../assets/image_1/397.png')" alt="">
          <div>
            <div class="bold c-fff fz-20 mb-15 lh-1">标准服务流程</div>
            <div class="c-939397 fz-18 w400 lh-1">重新定义服务高标准</div>
          </div>
        </div>
        <div class="flex-center">
          <img :src="require('../assets/image_1/399.png')" alt="">
          <div>
            <div class="bold c-fff fz-20 mb-15 lh-1">标准合作流程</div>
            <div class="c-939397 fz-18 w400 lh-1">全流程合规合作无忧</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-bottom">
      <div>
        <div class="flex-center">
          <img :src="require('../assets/image_1/logo_2.png')" />
        </div>
        <div class="flex mt-29">
          <img :src="require('../assets/image_1/433.png')" style="margin-right: 21px;" />
          <div>
            <div class="consult">咨询热线：</div>
            <div class="tel">152 1677 1448</div>
          </div>
        </div>
        <div class="email">邮箱：weiping@yunzmall.com</div>
        <div class="address">总部：广州市白云区机场路1600号汇创意产业园C2栋101+201+202</div>
        <div class="address-1">哈尔滨分部：哈尔滨高新技术产业开发区科技创新城创新创业广场1107号</div>
      </div>
      <div class="box-bottom-right">
        <div class="flex-column-center">
          <div class="head-tips">产品服务</div>
          <a href="https://www.yunzmall.com/plugins/shop_server/notice?class_id=32&i=10"   target="_blank"><div class="item">PPT介绍</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/goods/553301?i=10"   target="_blank"><div class="item">产品更新</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/microHome/microIndex?cat_id=27&i=10&mid=277"   target="_blank"><div class="item">产品发布</div></a>
        </div>
        <div class="flex-column-center ml-68">
          <div class="head-tips">资源中心</div>
          <a href="https://www.yunzmall.com/plugins/shop_server/microHome/microIndex?cat_id=newClassification&i=10&mid=277"   target="_blank"><div class="item">商家社区</div></a>
          <a href="https://www.yunzmall.com/addons/yun_shop/?menu#/case_library_home?i=10"   target="_blank"><div class="item">案例中心</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/liveList?i=10&type=5"   target="_blank"><div class="item">直播课堂</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/knowledge/home?i=10"   target="_blank"><div class="item">使用教程</div></a>
        </div>
        <div class="flex-column-center ml-68">
          <div class="head-tips">开发中心</div>
          <a href="https://www.yunzmall.com/plugins/shop_server/download?i=10&fromLogin=1"   target="_blank"><div class="item">免费下载</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/knowledge/knowledge_detail/21?i=10&base_id=17"   target="_blank"><div class="item">免费部署</div></a>
          <a href="https://wiki.yunzmall.com/docs/show/171 "   target="_blank"><div class="item">API文档</div></a>
          <a href="https://dev14.yunzmall.com/dictionaries/index.html"   target="_blank"><div class="item">数据字典</div></a>
        </div>
        <div class="flex-column-center ml-68">
          <div class="head-tips">关于芸众</div>
          <a href="#"><div class="item">芸众介绍</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/notice?class_id=0&i=10"   target="_blank"><div class="item">芸众动态</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/authorizationQuery?i=10"   target="_blank"><div class="item">授权查询</div></a>
          <a href="https://www.yunzmall.com/plugins/shop_server/register/agreement?enable=0&i=10"   target="_blank"><div class="item">用户协议</div></a>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footer-line"></div>
      <div class="footer-txt">广州市芸众信息科技有限公司 备案号：粤ICP备17018310号-3 粤公网安备：4401102002664号</div>
    </div>

    <!-- <div class="main">
      <div class="w-1200">
        <div class="main-content" style="padding:58px 0px 58px 0">
          <div class="main-left">
            <div class="list">
              <div class="title">产品服务</div>
              <div class="main-left-line"></div>
              <div class="ul">
                <a class="li" href="https://drive.weixin.qq.com/s?k=AKwA5gdpAA0A7Ji11i">产品介绍PPT</a>
                <a class="li" href="https://www.yunzmall.com/plugins/shop_server/articleContent/44?i=10">免费部署</a>
                <a class="li" href="https://www.yunzmall.com/plugins/shop_server/catelist/613?i=10">视频教程</a>
                <a class="li"
                  href="https://www.yunzmall.com/plugins/shop_server/register/agreement?enable=0&i=10">用户协议</a>
              </div>
            </div>
            <div class="list">
              <div class="title">资源中心</div>
              <div class="main-left-line"></div>
              <div class="ul">
                <a class="li"
                  href="https://www.yunzmall.com/plugins/shop_server/microHome/microIndex?cat_id=newClassification&i=10">商家社区</a>
                <a class="li"
                  href="https://www.yunzmall.com/plugins/shop_server/microHome/microIndex?cat_id=26&i=10">开发</a>
                <a class="li"
                  href="https://www.yunzmall.com/plugins/shop_server/microcommentdetails/185?i=10">VUE开源代码</a>
                <a class="li" href="https://www.yunzmall.com/plugins/shop_server/microcommentdetails/186?i=10">数据字典</a>
              </div>
            </div>
            <div class="list">
              <div class="title">解决方案</div>
              <div class="main-left-line"></div>
              <div class="ul">
                <a class="li" href="https://www.yunzmall.com/plugins/shop_server/goods/7442?i=10">智慧店铺解决方案</a>
                <a class="li" href="https://www.yunzmall.com/plugins/shop_server/goods/8195?i=10">知识付费解决方案</a>
                <a class="li" href="https://www.yunzmall.com/plugins/shop_server/goods/6799?i=10">电子合同私有化部署</a>
                <a class="li" href="https://www.yunzmall.com/plugins/shop_server/goods/7373?i=10">供应链中台系统</a>
              </div>
            </div>
            <div class="list">
              <div class="title">联系我们</div>
              <div class="main-left-line"></div>
              <div class="ul">
                <a class="li" href="javascript:void(0)">电话：15216771448</a>
                <a class="li" href="javascript:void(0)">邮箱：weiping@yunzmall.com</a>
                <a class="li" href="javascript:void(0)">地址：广州市白云区机场路1600号汇创意产业园C2栋2楼</a>
              </div>
            </div>
          </div>
          <div class="main-right">
            <div class="img-item">
              <img
                src="https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/0/2021/09/n47q79CeYzpp9YbfoyN97F9qqbFby9.jpg"
                alt="" style="width:130px;height:130px">
              <div class="text">合作咨询</div>
            </div>
            <div class="img-item" style=" margin-left: 50px;">
              <img src="https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/7c00e3dfbf2b977e1016e621809e98d0.jpg"
                alt="" style="width:130px;height:130px">
              <div class="text">关注公众号了解更多</div>
            </div>
          </div>
        </div>
        <div class="main-middle-line" style="padding:0 0 30px 0">
          <div style="height: 1px;background-color: #ffffff;"></div>
        </div>
        <div class="main-bottom">
          <a href="https://www.yunzmall.com" class="main-bottom-text">广州市芸众信息科技有限公司</a>
          <a href="https://beian.miit.gov.cn/" class="main-bottom-text"
            style="margin-left: 15px;">备案号：粤ICP备17018310号-3</a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011102002664" class="main-bottom-text"
            style="margin-left: 15px;">粤公网安备 44011102002664号</a>
        </div>
      </div>
    </div> -->


  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },

  methods: {},

  components: {},
};

</script>
<style scoped lang="scss">
.mb-15 {
  margin-bottom: 15px;
}

.flex-center {
  display: flex;
  align-items: center;
}

.fz-18 {
  font-size: 18px;
}

.lh-1 {
  line-height: 1;
}

.w400 {
  font-weight: 400;
}

.text-center {
  text-align: center;
}

.flex {
  display: flex;
}

.c-939397 {
  color: #939397;
}

.fz-24 {
  font-size: 24px;
}

.fz-20 {
  font-size: 20px;
}

.c-fff {
  color: #FFF;
}

.bold {
  font-weight: bold;
}

.part-ten-container {
  background-color: #000;
}

.part-ten {
  position: relative;
  height: 135px;
}

.part-ten::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  height: 1px;
  background-color: #fff;
}

.part-ten-top-content {
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  height: 100%;

}

.part-ten-top-content-item {
  display: flex;
  align-items: center;
}

.text {
  text-align: center;
  color: #ffffff;
  margin-left: 5px;
}

.h3 {
  margin: 0 0 16px;
  padding: 0;
  line-height: 22px;
  font-size: 22px;
}

.h4 {
  line-height: 16px;
  font-size: 14px;
}

a {
  text-decoration: none;
}

.main-left {
  display: flex;
  color: #ffffff;
}

.mt-29 {
  margin-top: 29px;
}

.tel {
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
}

.main-left-line {
  width: 80px;
  height: 4px;
  background-color: #ffffff;
  margin-top: 10px;
}

.email {
  font-weight: 400;
  font-size: 18px;
  color: #939397;
  line-height: 1;
  margin-top: 35px;
  margin-bottom: 29px;
  text-align: left;
  cursor: pointer;
}

.footer {
  width: 1200px;
  margin: 0 auto;
  padding-top: 99px;


}

.footer-txt {
  margin-top: 29px;
  text-align: center;
  padding-bottom: 92px;
  font-weight: 400;
  font-size: 18px;
  color: #939397;
}

.footer-line {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.5);
}

.address-1 {
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
  margin-top: 29px;
  text-align: left;
  color: #939397;
  cursor: pointer;
}

.address {
  font-weight: 400;
  font-size: 18px;
  color: #939397;
  line-height: 1;
  cursor: pointer;
  text-align: left;
}

.consult {
  font-weight: 400;
  font-size: 18px;
  cursor: pointer;
  color: #939397;
  line-height: 1;
  margin: 9px 0 11px;
}

.ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  font-size: 14px;
}

.ul .li {
  color: #ffffff;
  margin-top: 20px;
}

.list {
  margin-left: 50px;
}

.title {
  text-align: left;
  font-size: 20px;
}

.main {
  background-color: #091221;
}

.main .w-1200 .main-content {
  display: flex;
  justify-content: center;
}

.main .w-1200 .main-content .main-right {
  display: flex;
  align-items: center;
}

.img-item .text {
  margin-top: 20px;
}

.main-bottom {
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
}

.main-bottom-text {
  color: #ffffff;
}

.box-bottom {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  padding-top: 59px;
}

.flex-column-center {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.ml-68 {
  margin-left: 68px;
}

.box-bottom .item {
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 43px;
  line-height: 1;
  color: #939397;
  cursor: pointer;
}

.box-bottom .box-bottom-right {
  display: flex;
}

.box-bottom .head-tips {
  font-weight: bold;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 1;
  margin-bottom: 58px;
}
</style>